import { VisionApplication } from '../../application';
import { Measurement } from '../../components/measurement';
import { VisionSpreadingTab } from './spreading';

export class SpreaderSummaryCell {
    owner: VisionSpreadingTab;
    summaryGrid!: dhtmlXGridObject;

    constructor(owner: VisionSpreadingTab) {
        this.owner = owner;
        this.owner.rightLayout.cells('b').setText('Summary');
        this.owner.rightLayout.cells('b').collapse();

        this.summaryGrid = this.owner.rightLayout.cells('b').attachGrid();
        this.summaryGrid.setHeader('Asset,Start,Stop,Pulses,Total', ',', ['text-align:center;', 'text-align:center;', 'text-align:center;', 'text-align:center;', 'text-align:center;']);
        this.summaryGrid.setColAlign('left,center,center,center,center');
        this.summaryGrid.setColTypes('ro,ro,ro,ro,ro');
        this.summaryGrid.setColSorting('str,str,str,int,int');
        this.summaryGrid.init();
    }

    loadSummaryData(startUTC: number, endUTC: number) {
        this.owner.service?.getSummaryData(startUTC, endUTC).then((data) => {
            this.summaryGrid.clearAll(false);
            data.forEach((item) => {
                const rowData = [];

                const asset = VisionApplication.getInstance().assetService.assetList.get(item.assetId);
                if (asset) {
                    rowData.push(asset.id.name);
                    rowData.push(new Date(item.startTimeUTC).toLocaleString());
                    rowData.push(new Date(item.endTimeUTC).toLocaleString());
                    rowData.push(item.pulseCount);
                    rowData.push(Measurement.kg2pounds(asset.config.spreaderPulseKg * item.pulseCount)); // Assuming 'Total' is the same as 'Pulses' for now
                    console.log('Pulse: ' + asset.config.spreaderPulseKg);
                    console.log(item.pulseCount);

                    this.summaryGrid.addRow(item.assetId, rowData, 0, '', '', false);
                }
            });
        });
    }
}
